import { render, staticRenderFns } from "./PnoFooter.vue?vue&type=template&id=3ccc4d2f&"
import script from "./PnoFooter.vue?vue&type=script&lang=js&"
export * from "./PnoFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports